import { Injectable } from '@angular/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { MuiIconFont } from '../icon';
import { MuiToastConfig } from './mui-toast-config';


@Injectable({
  providedIn: 'root'
})
export class MuiToastService {
  defaultOptions: Partial<MuiToastConfig> = {
    toastType: 'info',
    iconFont: MuiIconFont.FONTAWESOME,
    hasAction: false
  };

  constructor(private toastService: ToastrService) {}

  show<T = unknown>(message: string, title?: string, options?: Partial<MuiToastConfig>): ActiveToast<T> {
    const defaultCopy = Object.assign({}, this.defaultOptions);
    const finalOptions = Object.assign(defaultCopy, options);
    const type = finalOptions.toastType || 'info';

    // Since v19.0.0, ngx-toastr has renamed 'danger' to 'error'
    return this.toastService.show(message, title, finalOptions, type === 'danger' ? 'error' : type);
  }

  success<T = unknown>(message: string, title?: string, options?: Partial<MuiToastConfig>): ActiveToast<T> {
    const toastTitle = title || '';
    const toastOptions = options ?? { toastType: 'success' };

    return this.showPredefinedToastType(message, toastTitle, toastOptions, 'success', 'check');
  }

  warning<T = unknown>(message: string, title?: string, options?: Partial<MuiToastConfig>): ActiveToast<T> {
    const toastTitle = title || '';
    const toastOptions = options ?? { toastType: 'warning' };

    return this.showPredefinedToastType(message, toastTitle, toastOptions, 'warning', 'exclamation-triangle');
  }

  danger<T = unknown>(message: string, title?: string, options?: Partial<MuiToastConfig>): ActiveToast<T> {
    const opt = Object.assign(
      {
        icon: 'exclamation-triangle',
        timeOut: 10000
      } as Partial<MuiToastConfig>,
      options
    );
    opt.toastType = 'danger';

    return this.show(message, title, opt);
  }

  private showPredefinedToastType<T = unknown>(
    message: string,
    title: string,
    options: Partial<MuiToastConfig>,
    toastType: string,
    icon?: string
  ): ActiveToast<T> {
    const opt = Object.assign({ icon }, options, { toastType });
    return this.show(message, title, opt);
  }
}
